import { render, staticRenderFns } from "./dragula.vue?vue&type=template&id=5ce533cf"
import script from "./dragula.vue?vue&type=script&lang=js"
export * from "./dragula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports